/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import type {
	usePermissionCheckPermissionCheckContentQuery as usePermissionCheckPermissionCheckContentQuery$data,
	usePermissionCheckPermissionCheckContentQueryVariables as usePermissionCheckPermissionCheckContentQuery$variables,
} from './__types__/usePermissionCheckPermissionCheckContentQuery.ts';

export const usePermissionCheck = (contentId: string) => {
	const { data, loading, error, refetch, networkStatus } = useQuery<
		usePermissionCheckPermissionCheckContentQuery$data,
		usePermissionCheckPermissionCheckContentQuery$variables
	>(
		gql`
			query usePermissionCheckPermissionCheckContentQuery($contentId: ID!) {
				content(id: $contentId) {
					nodes {
						id
						type
						operations {
							operation
							targetType
						}
					}
				}
			}
		`,
		{
			variables: {
				contentId,
			},
			notifyOnNetworkStatusChange: true,
			fetchPolicy: 'cache-and-network',
		},
	);

	const contentNode = data?.content?.nodes?.[0];
	const operations = contentNode?.operations ?? [];
	const contentType = contentNode?.type ?? undefined;

	const editPermission = operations.some(
		(operationResults) =>
			operationResults?.operation === 'update' && operationResults?.targetType === contentType,
	);

	return {
		canEdit: editPermission,
		loading,
		contentQueryError: error,
		refetch,
		networkStatus,
	};
};
